import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_HomePage = _resolveComponent("HomePage")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_FootPage = _resolveComponent("FootPage")!
  const _component_el_footer = _resolveComponent("el-footer")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_NavBar)
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_HomePage)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_FootPage)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}